module.exports = __webpack_public_path__ + "img/estatex.46325fc9.png";